// extracted by mini-css-extract-plugin
export default {"conteudo":"Pagina404_conteudo__+UAvj","container":"Pagina404_container__oQRcd","link":"Pagina404_link__b3tn7"};